




import { Vue, Component, Mixins, Prop } from "vue-property-decorator";
import { instanceOfIDrawableItemEditable } from "./IDrawableItemEditable";
import { DisableableMixin } from "../../system/mixins";
import Empty from "../../system/EmptyComponent.vue";
import TextBoxBehaviorEditor from "./behaviorEditors/TextBoxBehaviorEditor.vue";
import MovableTextBoxBehaviorEditor from "./behaviorEditors/MovableTextBoxBehaviorEditor.vue";
import DateBehaviorEditor from "./behaviorEditors/DateBehaviorEditor.vue";
import CircleSelectBehaviorEditor from "./behaviorEditors/CircleSelectBehaviorEditor.vue";
import ToggleFreeInputBehaviorEditor from "./behaviorEditors/ToggleFreeInputBehaviorEditor.vue";

@Component({
  components: {
    // ここに文書オブジェクトコンポーネントを記載要.DocuCoreとして考えると標準以外の文書オブジェクトをどうサポートするか？要検討.
    // TODO: とりあえず仮実装で未実装の物はNotImplementedで.
    LineItem: Empty,
    PolylineItem: Empty,
    TextBoxItem: TextBoxBehaviorEditor,
    MovableTextBoxItem: MovableTextBoxBehaviorEditor,
    RichTextBoxItem: Empty,
    BoxLineItem: Empty,
    CircleItem: Empty,
    TriangleItem: Empty,
    CrossItem: Empty,
    DateItem: DateBehaviorEditor,
    CircleSelectItem: CircleSelectBehaviorEditor,
    CalculateItem: ToggleFreeInputBehaviorEditor,
    ComboBoxItem: ToggleFreeInputBehaviorEditor,
    ImageItem: Empty,
    CheckBoxItem: Empty,
    NotImplementedItem: Empty,
    RollItem: ToggleFreeInputBehaviorEditor,
    ExternalDataItem: ToggleFreeInputBehaviorEditor,
    ExternalProcessItem: Empty,
    BarcodeItem: Empty,
    PositionCorrectItem: Empty,
    MovableImageItem: Empty,
    NewPageItem: Empty,
    GraphItem: Empty,
    RangeOfMotionItem: Empty,
    HeaderFooterTextItem: Empty,
    JoinTextItem: ToggleFreeInputBehaviorEditor,
  }
})
export default class BehaviorEditor extends Mixins(DisableableMixin) {
  @Prop()
  source: Vue;

  get isVisible(): boolean {
    return !!this.source;
  }

  get key(): string {
    return instanceOfIDrawableItemEditable(this.source)
      ? this.source.editingSource.typeKey
      : "";
  }
}
